<template>

	<v-app>

		<Header />

		<v-content>
			<slot></slot>
		</v-content>

		<Footer />

		<ModalDialog />

		<span id="btnStickyScrollToTop" @click="scrollToTop" class="material-icons iconSize24 stickyScrollToTop invisible">keyboard_arrow_up</span>

	</v-app>

</template>

<script>
import Logger from '@/assets/scripts/logger.js'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import ModalDialog from '@/components/ModalDialog'
import $ from 'jquery'

export default {
	name: 'Main',
	components: {
		Header,
		Footer,
		ModalDialog
	},
	data() {
		return {
			//
		}
	},
	beforeCreate() {
		Logger.log("Main.vue beforeCreate");
	},
	created() {
		Logger.log("Main.vue created");
		$( window ).on("scroll", this.scrollFunction);
	},
	beforeMount() {
		Logger.log("Main.vue beforeMount");
		// using css-vars-ponyfill for IE - see main.js
		if (this.$root.browser.name == "msie") {
			$("body").hide();
		}
	},
	mounted() {
		Logger.log("Main.vue mounted");
	},
	beforeUpdate() {
		Logger.log("Main.vue beforeUpdate");
	},
	updated() {
		Logger.log("Main.vue updated");
	},
	beforeDestroy() {
		Logger.log("Main.vue beforeDestroy");
		$( window ).off("scroll", this.scrollFunction);
	},
	destroyed() {
		Logger.log("Main.vue destroyed");
	},
	methods: {
		// scroll always to top of the current page
		// use smooth scrolling if device width greater than 512px
		scrollToTop() {
			var curBrowserWidth = window.innerWidth || (window.document.documentElement.clientWidth || window.document.body.clientWidth);
			if (curBrowserWidth > 512) {
				$("html, body").animate({ scrollTop: 0 }, "slow");
			} else {
				document.body.scrollTop = 0; // For Safari
				document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
			}
		},
		// for sticky button scroll to top
		// when the user scrolls down 60px from the top of the document, show the button
		scrollFunction() {
			if (document.body.scrollTop > 60 || document.documentElement.scrollTop > 60) {
				$("#btnStickyScrollToTop").removeClass("invisible");
			} else {
				$("#btnStickyScrollToTop").addClass("invisible");
			}
		}
	}
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';

	.stickyScrollToTop {
		position: fixed; /* Fixed/sticky position */
		bottom: 0.75rem; /* Place the button at the bottom of the page */
		right: 0.75rem; /* Place the button 2rem from the right */
		z-index: $zIndexLoading; /* Make sure it does not overlap (note z-index of chatWnd, backgroundLayer and dialog), lower that chat wnd (21)  */
		border: none; /* Remove borders */
		outline: none; /* Remove outline */
		background-color: $globColSec; /* Set a background color */
		color: white; /* Text color */
		cursor: pointer; /* Add a mouse pointer on hover */
		padding: 0.25rem; /* Some padding */
		border-radius: 50%; /* Rounded */
		opacity: 0.5; /* Opacity for the button */

		&:hover {
			@include skinColor(background-color, --skinColSec, $skinColSec);  /* Add a dark-grey background on hover */
			opacity: 1.0; /* Reset opacity for the button */
		}
	}

</style>
